import { isNil } from 'lodash';
import moment from 'moment-timezone';
import React from 'react';
import { unixToDate } from 'utils/date';

const styleTime = timestamp => {
    // A nil or 0 (epoch) timestamp means there is no data yet — e.g. a measurement
    // that has never acquired. Render nothing instead of "1970/01/01 - (57 years ago)".
    if (isNil(timestamp) || timestamp === 0) {
        return '';
    }

    return (
        <React.Fragment>
            {unixToDate(timestamp)}&nbsp;-&nbsp;
            <span>
        ({moment.duration(timestamp - moment().unix(), 'seconds').humanize(true)})
            </span>
        </React.Fragment>
    );
};

export default styleTime;
